import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateBeneficiarioAnimales, 
    insertBeneficiarioAnimales,
    deleteBeneficiarioAnimales,
    serverMensaje } from '../../redux/reducers/beneficiarios';
import {highlightAll, disableNewlines, pastePlainText } from '../../utils/utils';
import {showToaster} from './BenefShowMesg';
import ContentEditable from 'react-contenteditable';
import Alert, {AlertMessage} from 'calcite-react/Alert';
import Table, {
    TableHeader,
    TableHeaderRow,
    TableHeaderCell,
    TableBody,
    TableRow,
    TableCell
} from 'calcite-react/Table';
import Select from 'calcite-react/Select';
import {MenuItem} from 'calcite-react/Menu';
import Button from 'calcite-react/Button';

import SaveIcon from 'calcite-ui-icons-react/SaveIcon';
import TrashIcon from 'calcite-ui-icons-react/TrashIcon';
import UserPlusIcon from 'calcite-ui-icons-react/UserPlusIcon';

import tipoAnimales from '../../data/vivienda_animales.json';
import tipoEstadoAnimal from '../../data/estado_animales.json';


const BenefAnimales = ({animales, beneficiarioId}) => {
    const dispatch = useDispatch();
    const mensaje = useSelector(state => state.beneficiarios.mensaje);
    const users = useSelector(state => state.users);
    // const isEditable = users.user.tipo==='ADMINISTRADOR' ? true : false;
    const isEditable = (users.user.areatrabajo==='ADMINISTRATIVA' || users.user.areatrabajo==='TRABAJO SOCIAL' || users.user.areatrabajo==='COORDINACIÓN' || users.user.areatrabajo==='PSICOLOGÍA' ) ? true : false;
    const [isBtnAddEnable, setIsBtnAddEnable] = useState(false);
    const [error, setError] = useState(null);
    const [A, updateA] = useState([...animales]); //Object.assign({}, animales); // Arreglos no Objects

    // let A = [...animales]; //Object.assign({}, animales); // Arreglos no Objects

    useEffect(() => {
        // 
        return () => {
            dispatch(serverMensaje({}));
        }
    }, [dispatch]);

    useEffect(() => {

        if (mensaje.animales && mensaje.animales!=='') {
            const insertAnimales = (id, f, v) => {
                if (A){
                    updateA(A.map((itm, index) => {
                        if (itm.id===id){
                            itm[f] = v;
                        }
                        return itm;
                    }));
                    mensaje.animales='';
                    // dispatch(serverMensaje({animales:''}));
                }
            };

            if (typeof mensaje.animales === 'string' && mensaje.animales.toLowerCase().includes('error')){
                showToaster('error', 'Ocurrió un fallo en el servidor', mensaje.animales);
            } 
            else {
                showToaster('success',"Animales del Beneficiario", mensaje.animales.split('.')[0]);
                // Update Id for edition
                // Cambiar el id por el que devuelve el servidor o transacción de MySQL
                insertAnimales('-1', 'id', String(mensaje.animales.split('.')[1]));
            }
        }

    }, [mensaje.animales, updateA, A, dispatch]);
    
    const updateAnimales = (id, f, v) => {
        if (A){
            updateA(A.map((itm, index) => {
                if (itm.id===id){
                    itm[f] = v;
                }
                return itm;
            }));
        }
    };

    const updateDataonServer = (id, action, newItem) =>{
        dispatch(serverMensaje({animales:''}));
        switch (action) {
            case 'insert':
                if (parseInt(id)< 0 && newItem){
                    // console.log('insertando nuevo registro: ', newItem);
                    setIsBtnAddEnable(true);
                }
                break;
            case 'save':
                if (id){
                    const reg = A.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(insertBeneficiarioAnimales( { token: users.user.claveAPI, animales:reg[0]}));
                        setIsBtnAddEnable(false);
                    }
                }
                break;
            case 'remove':
                if (id){
                    const reg = A.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(deleteBeneficiarioAnimales( { token: users.user.claveAPI, animales:reg[0]}));
                    }
                }
                break;
            default: // update
                // Actualizar solo el registro necesario, para no enviar toda la tabla
                if (id && parseInt(id) > 0){
                    const reg = A.filter(itm => itm.id===id);
                    if (reg && reg.length>0){
                        dispatch(updateBeneficiarioAnimales( { token: users.user.claveAPI, animales:reg[0]}));
                    }
                }
                break;
        }
    }

    const replaceSomeText = (s) =>{
        return s
            .replace(/&nbsp;/g, '')
            .replace(/<br>/g, '')
            .replace(/&amp;/g, '&')
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<').trim()
    }

    const validateInput = (f, v, final) => {
        const regex_onlynum = /^[0-9]*$/i; ///[0-9,]|\./;
        // const regex_nombres = /^['`´a-zA-ZÀ-ÿ\u00C0-\u017F\s]+$/;
        let new_val = null;
        let err = null;
        switch (f) {
            case 'nombre':
                new_val = v.substr(0,32);
                if (final)
                    new_val = replaceSomeText(v).substr(0,32);
                break;
            case 'cantidad':
                new_val = replaceSomeText(v);
                if (!regex_onlynum.test(new_val)) {
                    err = 'Dígite solo números válidos';
                    new_val = null;
                }
                if (new_val===null) new_val = '';
                break;
            case 'estado':
                new_val = v.substr(0,32);
                if (final)
                    new_val = replaceSomeText(v).substr(0,32);
                break;
            
            // case 'comentarios':
            //     new_val = replaceSomeText(v); //.substr(0,255);
            //     break;
            default:
                break;
        }
        setError(err);
        return new_val
    }

    const handleClaseSelectChange = (value, id) => {
        A['nombre'] = value;
        updateAnimales(id,'nombre', value );
        updateDataonServer(id);
    };

    const handleEstadoSelectChange = (value, id) => {
        A['estado'] = value;
        updateAnimales(id,'estado', value );
        updateDataonServer(id);
    };

    const handleChange = evt => {
        const [, field, id] = evt.currentTarget.id.split('_');
        const new_val = validateInput(field, evt.target.value, false);
        if(new_val){
            updateAnimales(id,field, new_val );
            // console.log("tabla, field, id", tabla, field, id, new_val);
        };

    };
    const handleBlur = evt => {
        const val = evt.currentTarget.innerHTML;
        const [,field, id] = evt.target.id.split('_');
        const new_val = validateInput(field, val, true)
        if(new_val || new_val===''){
            // console.log("tabla, field, id", tabla, field, id, val);
            updateAnimales(id,field, new_val );
            updateDataonServer(id);
        };
    };

    const onClickAddAnimales = () => {
        const newId = -1;
        const nuevo_animal = {
            "id": String(newId),
            "beneficiarioId": beneficiarioId,
            "nombre": "",
            "cantidad": "0",
            "estado": "",
            // "version": "2020-06-03 10:03:03"
        }
        updateA([...A].concat(nuevo_animal) );
        updateDataonServer(newId, 'insert', nuevo_animal);
    }
    const onClickSaveAnimales = (id) => {
        updateDataonServer(id, 'save');
    }
    const onClickRemoveAnimales = (id) => {
        updateA([...A].filter(itm => itm.id!==id));
        updateDataonServer(id, 'remove');
    }

    return (
        <div>
            { error && <div style={{color: 'red', width: '100%'}}>
                <Alert red showIcon style={{minWidth: '100%', marginBottom: '10px'}}
                    showCloseLabel 
                    onClose={() => setError(null)}>
                    <AlertMessage>
                        Error:{' '}
                        <strong>{error}</strong>
                    </AlertMessage>
                </Alert>
                </div>
            }
            <div className="itemContainer-table-animales">
            <Table striped>
                <TableHeader>
                    <TableHeaderRow>
                        <TableHeaderCell style={{textAlign:'center'}}>Clase</TableHeaderCell>
                        <TableHeaderCell style={{textAlign:'center'}}>Cuántos</TableHeaderCell>
                        <TableHeaderCell style={{textAlign:'center'}}>Estado</TableHeaderCell>
                        <TableHeaderCell style={{textAlign:'center'}}>Acción</TableHeaderCell>
                    </TableHeaderRow>
                </TableHeader>
                <TableBody>
                    {
                        A.map((ah, index) => (
                            <TableRow key={ah.id}>
                                <TableCell style={{maxWidth:'120px'}}>
                                    <Select filterable positionFixed disabled={!isEditable} 
                                        id={'animales_nombre_'+ah.id}
                                        className={'itemContainer-table-selects'}
                                        onChange={(value, item) => handleClaseSelectChange(value, ah.id)}
                                        selectedValue={ah.nombre.trim()}
                                    >
                                    {tipoAnimales.tipo.map(p => {
                                        return (
                                        <MenuItem key={p.id} value={p.name}>
                                            {p.name}
                                        </MenuItem>
                                        )
                                    })}
                                    </Select>
                                </TableCell>
                                <TableCell style={{minWidth:'80px'}}>
                                    <ContentEditable
                                        id={'animales_cantidad_'+ah.id}
                                        html={ah.cantidad || ''} // innerHTML of the editable div
                                        // style={{textAlign:'center'}}
                                        className='itemContainer-value-table'
                                        disabled={!isEditable}      // use true to disable editing
                                        onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                        onChange={handleChange} // handle innerHTML change
                                        onKeyPress={disableNewlines}  
                                        onFocus={highlightAll}
                                        onBlur={handleBlur}
                                        tagName='div' // Use a custom HTML tag (uses a div by default)
                                    />
                                </TableCell>
                                {/* <TableCell style={{minWidth:'140px'}}>
                                    <ContentEditable
                                        id={'animales_estado_'+ah.id}
                                        html={ah.estado || ''} // innerHTML of the editable div
                                        // style={{textAlign:'center'}}
                                        className='itemContainer-value-table'
                                        disabled={!isEditable}      // use true to disable editing
                                        onPaste={pastePlainText} // En caso se copie y pegue de otra pagina de internet
                                        onChange={handleChange} // handle innerHTML change
                                        onKeyPress={disableNewlines}  
                                        onFocus={highlightAll}
                                        onBlur={handleBlur}
                                        tagName='div' // Use a custom HTML tag (uses a div by default)
                                    />
                                </TableCell> */}
                                <TableCell style={{maxWidth:'120px'}}>
                                    <Select filterable positionFixed disabled={!isEditable} 
                                        id={'animales_estado_'+ah.id}
                                        className={'itemContainer-table-selects'}
                                        onChange={(value, item) => handleEstadoSelectChange(value, ah.id)}
                                        selectedValue={ah.estado.trim()}
                                    >
                                    {tipoEstadoAnimal.tipo.map(p => {
                                        return (
                                        <MenuItem key={p.id} value={p.value}>
                                            {p.name}
                                        </MenuItem>
                                        )
                                    })}
                                    </Select>
                                </TableCell>
                                <TableCell style={{maxWidth:'140px'}}>
                                    {
                                        (parseInt(ah.id)< 0)
                                        ?
                                        <Button extraSmall clear iconPosition="before"
                                            disabled={!isEditable} 
                                            id={'animales_guardar_'+ah.id}
                                            onClick={(evt) => onClickSaveAnimales(ah.id)}
                                            icon={<SaveIcon size={16} />}
                                        >
                                            Guardar
                                        </Button>
                                        :
                                        <Button extraSmall clear iconPosition="before"
                                            disabled={!isEditable} 
                                            id={'animales_eliminar_'+ah.id}
                                            onClick={(evt) => onClickRemoveAnimales(ah.id)}
                                            icon={<TrashIcon size={16} />}
                                        >
                                            Eliminar
                                        </Button>
                                    }
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            </div>

            <div className="">
                <Button iconPosition="before" 
                    disabled={!isEditable || isBtnAddEnable} 
                    id={'animales_agregar'}
                    onClick={onClickAddAnimales}
                    icon={<UserPlusIcon size={16} />}
                >
                    Agregar nuevo animal
                </Button>
            </div>
        </div> 
    );
}
   
export default BenefAnimales;

